import { getCourse, getCurrentPromotion, getPromotionCohorts, getPromotionPlans } from '~/utility/fetchAPI'

export function usePromotion(category?: 'course' | 'set' | null, screenName?: string) {
  const api = useNuxtApp().$api

  const currentPromotion = ref<any | null>(null)
  const promotionCohorts = ref<number[] | null>(null)
  const promotionPlans = ref<number[] | null>(null)
  const course = ref<any | null>(null)

  const { pack, packPlans } = (category === 'set' && screenName ? usePack(screenName) : {pack: ref<any | null>(null), packPlans: ref<any | null>(null)})
  const title = computed(() => {
    return currentPromotion.value?.attributes.title
  })

  onMounted(async () => {
    try {
      currentPromotion.value = (await getCurrentPromotion(api))?.data
      if (screenName) {
        promotionCohorts.value = (await getPromotionCohorts(api, screenName))?.data
        promotionPlans.value = (await getPromotionPlans(api, screenName))?.data
      }
      if (category === 'course' && screenName) {
        course.value = (await getCourse(api, screenName, {}))?.data
      }
    } catch (error) {
      return false
    }
  })

  function selectedPackPlan(entryCohortSelected: string, entryPlanSelected: string) {
    // Cohort == Pack
    const selectedCohort = packPlans.value?.find((pack: any) => {
      return Number(pack.id) === Number(entryCohortSelected)
    })
    const plans = [
      ...selectedCohort.attributes.collection_for_social_plans,
      ...selectedCohort.attributes.collection_for_student_plans,
    ]
    return plans.find((plan: any) => {
      return Number(plan.id) === Number(entryPlanSelected)
    })
  }

  function isVisible(): boolean {
    // currentPromotion && isCoursePromoted
    return (
      currentPromotion.value !== null && promotionCohorts.value !== null && promotionPlans.value !== null
    ) && isPromoted()
  }

  function isCourseInPromotion(entryPlanSelected: string, entryCohortSelected: string): boolean {
    if (course.value == null || currentPromotion.value == null) {
      return false
    }

    if (
      promotionPlans.value?.includes(Number(entryPlanSelected))
      && promotionCohorts.value?.includes(Number(entryCohortSelected))
    ) {
      return true
    } else {
      return false
    }
  }

  function isPromoted(): boolean {
    return currentPromotion.value?.attributes.screen_names.includes(screenName)
  }

  function isSetInPromotion(entryStudentSelected: string, entryPlanSelected: string, entryCohortSelected: string) {
    if (!isPromoted()) { return false }

    if (pack.value == null || packPlans.value == null || !entryStudentSelected || !entryPlanSelected) {
      return false
    }

    const planWeeks = selectedPackPlan(entryCohortSelected, entryPlanSelected).weeks.toString()
    if (
      currentPromotion.value?.attributes.weeks.includes(planWeeks)
      && promotionCohorts.value?.includes(Number(entryCohortSelected))
    ) {
      return true
    } else {
      return false
    }
  }

  return {
    currentPromotion,
    promotionCohorts,
    promotionPlans,
    selectedPackPlan,
    isCourseInPromotion, // コースにおいて、選択されたものがキャンペーン対象か
    isPromoted, // スクリーン名がキャンペーン対象か
    isSetInPromotion, //セットにおいて、選択されたものがキャンペーン対象か
    isVisible, // キャンペーンを表示するか
    title, // キャンペーン名
  }
}
